import PageWrapper from '@/components/app/PageWrapper';
import { Button } from '@/components/ui/Button';

const SupportPage = () => {
  return (
    <PageWrapper>
      <div className="w-full h-full flex flex-col items-center justify-center p-12 bg-gradient-to-r from-[#DCECFB] via-[#F0F4D4] to-[#FAF3E0]">
        <div className="flex flex-col w-full items-center">
          <h1 className="text-3xl md:text-6xl font-bold w-full md:w-[706px] text-center text-[#1C1C1C] leading-tight">
            We're here to help!
          </h1>
          <p className="text-lg md:text-2xl font-medium my-6 w-full md:w-[706px] text-center text-[#1C1C1C]">
            If you have questions or concerns about donating to a cause, please
            reach out to us at{' '}
            <a
              href="mailto:giving@gather25.com"
              className="underline decoration-[#7F7F79] underline-offset-4"
            >
              giving@gather25.com
            </a>
            .
          </p>
          <div className="mt-8 flex flex-col md:flex-row gap-6">
            <Button
              className="w-[224px] bg-[#0E1E2C] text-[#FAF3E0] hover:bg-[#0C1923] shadow-lg"
              onClick={() =>
                window.open(
                  'https://www.gather25.com/about',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            >
              OUR STORY
            </Button>
            <Button
              className="w-[224px] text-[#1C1C1C] border-[#1C1C1C] hover:bg-[#E5E5E5] bg-transparent border"
              onClick={() =>
                window.open(
                  'https://www.gather25.com/faqs',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
            >
              FAQ
            </Button>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default SupportPage;
